var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export function newFlowStepShapeSettings(data) {
    var instance = {
        __type: "FlowStepShapeSettings:#DecisionsFramework.Design.Flow",
        ShapeType: 2 /* FlowStepShapeType.Square */,
        WaypointType: 0 /* FlowStepWaypointType.Circle */,
        ShapeSettings: null,
        HasImage: false,
        Image: null,
        ImageOpacity: 100,
        ImageWidth: 48,
        ImageHeight: 48,
        Width: null,
        Height: null,
        OverrideFont: false,
        FontAttributes: null,
        FontAttributesInfo: null,
        FontColorInfo: null
    };
    return __assign(__assign({}, instance), data);
}
export function isFlowStepShapeSettings(object) {
    return object.__type === "FlowStepShapeSettings:#DecisionsFramework.Design.Flow";
}
